import React, { Component } from "react";
import { Card, Drawer, Tooltip, Button, Form, Row, Col, Icon, notification, Alert } from "antd";
import { connect } from "react-redux";
import { TableComp } from "sz-react-utils";
import Request, { LAPI_URL } from "../../request";
import ListStudentFollowUp from '../_utils/listFollowUp';
import InquiryReviewDrawer from './inquiryReviewDrawer';
import moment from "moment";
import LatestFollowup from "../_utils/latestFollowup";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import _ from 'lodash';
import InquiryReviewModal from "../modals/inquiryReviewModal";

const desks = [
    { _id: 'Operation Manager Desk', display: 'Operation Manager Desk' },
    { _id: 'Front Desk', display: 'Counselling Desk' },
    { _id: 'Registration Desk', display: 'Registration Desk' },
    { _id: 'Application Desk', display: 'Application Desk' },
    { _id: 'Visa Desk', display: 'Visa Desk' },
];
let studentObj = {}

const currentUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

@Form.create()
class RejectInquiryDrawer extends Component {
    state = {
        visible: true,
        loading: false,
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    handleSubmit = (e) => {
        e.preventDefault()
        let { form, recordId } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values._id = recordId;
            this.setState({ loading: true });
            let response = await Request.rejectMoveToClaimRequest(values);
            this.setState({ loading: false });
            if (response.success) {
                notification.success({ message: response.message })
            } else {
                notification.error({ message: response.message })
            }
            this.onClose();
        })
    }

    render() {
        const withTooltip = (label, message) => (
            <span>
                {label}
                <Tooltip title={message}>
                    <Icon type="question-circle" style={{ marginLeft: 6, color: '#1890ff', cursor: 'pointer' }} />
                </Tooltip>
            </span>
        );
        let { visible } = this.state;
        let { form: { getFieldDecorator, setFieldsValue, getFieldValue } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: "Rollback To",
                    key: 'atLevel',
                    type: 'select',
                    options: desks,
                    required: true,
                    onChange: v => {
                        setFieldsValue({ atLevel: v })
                    }
                },
                {
                    label: withTooltip(
                        'Reject Reason',
                        'A task will be created for the visa user using this description.'
                    ),
                    key: 'rejectReason',
                    hidden: !getFieldValue('atLevel'),
                    type: 'textarea',
                    required: true,
                }
            ]
        }
        return (
            <Drawer
                title={<div><React.Fragment>Reject Reason</React.Fragment></div>}
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={500}
                visible={visible}>
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

class MoveToClaimRequestDrawer extends Component {
    state = {
        visible: true,
        total: 0,
        showStudentFollowUp: false,
        inquiryDetail: null,
        showReviewDrawer: false,
        showRejectDrawer: false,
        recordId: null,
        loading: false,
        showReviewModal: false,
        selectedInquiryId: null
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose();
        }, 100);
    }

    openStudenFollowUps = (record) => {
        studentObj = {
            arr: record.followUp,
            name: record.studentName,
            rating: record.counsellingDesk.rating,
            subRating: record.counsellingDesk.subRating,
            _id: record._id,
        };
        this.setState({ showStudentFollowUp: true });
    };

    // चेक बटन/ऑटोमैटिक अप्रूवल एपीआई
    approveClaimApplication = async (recordId) => {
        this.setState({ loading: true });
        let response = await Request.approveMoveToClaimRequest({ _id: recordId });
        this.setState({ loading: false });
        if (response.success) {
            notification.success({ message: response.message || "Moved to claim desk successfully" });
            if (this.table.current) this.table.current.reload();
        } else {
            notification.error({ message: response.messsage || "Failed to move to claim desk" });
        }
    }

    rejectClaimApplication = (recordId) => {
        this.setState({ showRejectDrawer: true, recordId });
    }

    closeRejectClaimApplication = () => {
        this.setState({ showRejectDrawer: false, recordId: null }, () => {
            this.table.current.reload();
        })
    }

    closeStudentFollowUp = () => {
        this.setState({ showStudentFollowUp: false }, () => {
            this.table.current.reload();
        })
    }

    closeReviewDrawer = () => {
        this.setState({ inquiryDetail: {}, showReviewDrawer: false }, () => {
            this.table.current.reload();
        })
    }

    // ✅ यहाँ ऑटोमेशन हैंडल किया गया है: मोडल क्लोज होते ही चेक आइकॉन वाली एपीआई ऑटोमैटिक हिट होगी
    handleModalActionSuccess = (recordId) => {
        this.setState({ showReviewModal: false, selectedInquiryId: null, loading: true }, () => {
            if (recordId) {
                // मोडल अप्रूव होते ही चेक आइकॉन वाली एपीआई को ऑटोमैटिकली कॉल करेगा
                this.approveClaimApplication(recordId);
            } else {
                if (this.table.current) this.table.current.reload();
            }
        });
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.getMoveToClaimRequest(params);
            this.setState({ total: response.total });
            return resolve(response);
        })
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    render() {
        let { visible, total, showStudentFollowUp, showReviewDrawer, inquiryDetail, showRejectDrawer, recordId, showReviewModal, selectedInquiryId } = this.state;
        let columns = [
            {
                title: 'Action',
                key: 'operation',
                width: 120,
                align: 'center',
                render: (text, record) => {
                    let isLastFollowupByMe = record && record.followUp && record.followUp.assignByUserId === currentUser._id ? true : false;

                    return (
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                            <Tooltip title="Add Mandatory Follow-up">
                                <Button
                                    onClick={() => this.openStudenFollowUps(record)}
                                    shape="circle"
                                    icon="calendar"
                                    type={isLastFollowupByMe ? "default" : "primary"}
                                />
                            </Tooltip>

                            {isLastFollowupByMe ? (
                                <Tooltip title="Review Checklist & Process Approval">
                                    <Button
                                        type="primary"
                                        style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                                        onClick={() => this.setState({ showReviewModal: true, selectedInquiryId: record._id })}
                                        shape="circle"
                                        icon="eye"
                                    />
                                </Tooltip>
                            ) : (
                                <Tooltip title="Follow-up is mandatory before you can review data details">
                                    <Button
                                        type="default"
                                        disabled
                                        shape="circle"
                                        icon="eye"
                                        style={{ opacity: 0.5 }}
                                    />
                                </Tooltip>
                            )}
                        </div>
                    )
                }
            },
            { title: "ID", key: "id" },
            { title: "Student Name", key: "studentName", filterRegex: true },
            {
                title: "DOB ",
                width: 100,
                key: "dateOfBirth",
                render: (val, record) => (
                    <div>{record.dateOfBirth ? moment(record.dateOfBirth).format("DD-MMM-YYYY") : ""}</div>
                ),
            },
            { title: "Desk", key: "atLevel" },
            { title: "Source", key: "location" },
            { title: "Mode", key: "mode" },
            {
                title: "Counsellor",
                key: "counsellorId",
                render: (text, record) => <div>{record.counsellorId ? record.counsellorId.name : ""}</div>,
            },
            {
                title: "Follow Up",
                key: "followUp.followUpDate",
                width: 200,
                dataIndex: "followUp",
                render: (text) => <LatestFollowup info={text} />,
            },
            {
                title: "Last Updated By",
                width: 150,
                key: "updatedByUser",
                render: (text) => (
                    <div>
                        <div>{text ? text.name : ""}</div>
                        <small>{text ? moment(text.time).format("lll") : ""}</small>
                    </div>
                ),
            }
        ];

        return (
            <Drawer
                title={`Move Claim Requests:- ${total}`}
                placement="right"
                onClose={this.onClose}
                visible={visible}
                width={1000}
            >
                <Card bordered={true}>
                    <Alert
                        message="Verification Guidelines for Claim Desk Users"
                        description={
                            <ul style={{ paddingLeft: '15px', marginBottom: 0 }}>
                                <li><strong>Mandatory Follow-up First:</strong> You must log a new follow-up statement for the student to unlock the operational checklist review view.</li>
                                <li><strong>Checklist Verification:</strong> Open the view modal to confirm structural ledger items and paperwork accuracy before moving forward.</li>
                                <li><strong>Automated Execution:</strong> Approving inside the modal automatically updates the ledger checklists and flags the student to auto-generate Proforma Invoices (PIs).</li>
                            </ul>
                        }
                        type="info"
                        showIcon
                        style={{ marginBottom: '20px' }}
                    />

                    {showReviewModal && (
                        <InquiryReviewModal
                            visible={showReviewModal}
                            inquiryId={selectedInquiryId}
                            onClose={() => this.setState({ showReviewModal: false, selectedInquiryId: null })}
                            onSuccess={this.handleModalActionSuccess}
                        />
                    )}

                    {showStudentFollowUp ? <ListStudentFollowUp studentObj={studentObj} onClose={this.closeStudentFollowUp} /> : null}
                    {showReviewDrawer ? <InquiryReviewDrawer details={inquiryDetail} onClose={this.closeReviewDrawer} /> : null}
                    {showRejectDrawer ? <RejectInquiryDrawer recordId={recordId} onClose={this.closeRejectClaimApplication} /> : null}

                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 50,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search
})

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(MoveToClaimRequestDrawer)